import userStore from "./user/User.Store";
import contractorStore from "./contractor/Contractor.Store";
import projectStore from "./project/Project.Store";
import languageStore from "./language/Language.Store";
import contactStore from "./contact/Contact.Store";
import companyInfoStore from './companyInfo/CompanyInfo.Store';
import fieldStore from './fieldMasterData/fieldMasterData.Store';
import biddingCategoryStore from './biddingCategory/BiddingCategory.Store';
import cartOrderStore from './cartOrder/CartOrder.Store';

export default {
  userStore, 
  contractorStore, 
  languageStore, 
  projectStore, 
  contactStore,
  companyInfoStore,
  fieldStore,
  biddingCategoryStore,
  cartOrderStore
};


// WEBPACK FOOTER //
// ./src/services/_store.js